import React from "react";

export const renderDescription = (description) => {
  if (!description) {
    return null;
  }
  return description.map((block, index) => {
    if (block.type === "ul") {
      return (
        <ul key={index} className="list-disc list-inside pl-5 mb-4">
          {block.children.map((li, i) => (
            <li key={i}>
              {li.children.map((child, j) => {
                let element = <>{child.text}</>;
                if (child.bold) {
                  element = <strong>{element}</strong>;
                }
                if (child.italic) {
                  element = <em>{element}</em>;
                }
                if (child.type === "link") {
                  return (
                    <a
                      href={child.url}
                      key={j}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline"
                    >
                      {child.children.map((linkChild, k) => (
                        <React.Fragment key={k}>
                          {linkChild.text}
                        </React.Fragment>
                      ))}
                    </a>
                  );
                }
                return <React.Fragment key={j}>{element}</React.Fragment>;
              })}
            </li>
          ))}
        </ul>
      );
    } else if (block.children) {
      return (
        <p key={index} className="mb-4">
          {block.children.map((child, i) => {
            let element = <>{child.text}</>;
            if (child.bold) {
              element = <strong>{element}</strong>;
            }
            if (child.italic) {
              element = <em>{element}</em>;
            }
            if (child.type === "link") {
              return (
                <a
                  href={child.url}
                  key={i}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  {child.children.map((linkChild, k) => (
                    <React.Fragment key={k}>{linkChild.text}</React.Fragment>
                  ))}
                </a>
              );
            }
            return <React.Fragment key={i}>{element}</React.Fragment>;
          })}
        </p>
      );
    }
    return null;
  });
};
